<template>
  <div>
    <v-dialog persistent v-model="showDialog" max-width="800" class="mx-auto">
      <v-card outlined :loading="this.loading">
        <v-card-title class="my-2">{{$t('technique.title_singular')}}</v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-text-field outlined
              autofocus
              v-model="technique.name"
              :rules="requiredRules"
              v-on:keyup.enter="saveTechnique"
              :counter="255"
              :label="$t('technique.name')">
            </v-text-field>
          </v-form>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text
            @click="$emit('onCancel')">{{$t('common_actions.cancel')}}</v-btn>
          <v-btn outlined color="primary" @click="saveTechnique">{{$t('common_actions.save')}}</v-btn>
        </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="showErrorSnackbar" color="error">
      {{ this.snackbarErrorText }}
    </v-snackbar>
  </div>
</template>

<script>
import i18n from '@/plugins/i18n'

export default {
  name: 'TechniqueEdit',
  props: ['initTechnique', 'showDialog'],
  data: () => ({
    technique: {
      id: 0,
      name: '',
      index: -1
    },
    requiredRules: [
      v => !!v || i18n.t('common_field_error.field_required')
    ],
    showErrorSnackbar: false,
    snackbarErrorText: '',
    loading: false,
    showDialogLocal: false
  }),
  watch: {
    showDialog () {
      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    }
  },
  created () {
    this.showDialogLocal = this.showDialog
    this.technique = this.initTechnique
  },
  methods: {
    saveTechnique () {
      if (!this.$refs.form.validate() || this.loading) {
        return
      }
      this.loading = true
      if (this.technique.id <= 0) {
        this.$store.dispatch('techniques/addNewTechnique', this.technique).then(result => {
          this.loading = false
          this.$emit('onSave')
        }, error => {
          this.loading = false
          if (error.response.data !== null) {
            this.snackbarErrorText = i18n.t('common_error_code.' + error.response.data)
            this.showErrorSnackbar = true
          } else {
            this.snackbarErrorText = i18n.t('common_error.could_not_add_item')
            this.showErrorSnackbar = true
          }
        })
      } else {
        this.$store.dispatch('techniques/editTechnique', this.technique).then(result => {
          this.loading = false
          this.$emit('onSave')
        }, error => {
          this.loading = false
          if (error.response.data !== null) {
            this.snackbarErrorText = i18n.t('common_error_code.' + error.response.data)
            this.showErrorSnackbar = true
          } else {
            this.snackbarErrorText = i18n.t('common_error.could_not_edit_item')
            this.showErrorSnackbar = true
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/codebooks/editors/TechniqueEdit.vue